/** @format */
import 'angular';
import 'angular-translate';
import _ from 'lodash';
import '../model/gradeScale.model';
import '../model/publicPerson.model';
import '../model/studentApplication.model';
import '../model/organisation.model';
import '../service/attainment.service';
import { localizedUrnNameDisplayModule } from '../codes/localizedUrnNameDisplay.component';
import { decimalNumberFilterModule } from '../number/decimalNumber.filter';
import { personNameAndTitleModule } from '../person/personNameAndTitle.component';
import { MarkupStringComponent } from '../string/markup-string/markup-string.component';
import attainmentApplicationDecisionSummaryTpl from './attainmentApplicationDecisionSummary.tpl.html';
import { textWithDefaultMissingValueModule } from './textWithDefaultMissingValue.component';

export const attainmentApplicationDecisionSummaryModule = 'sis-components.applications.attainmentApplicationDecisionSummary';

(function () {
    attainmentApplicationDecisionSummaryController.$inject = [
        '$q',
        '$scope',
        'gradeScaleJSDataModel',
        'commonAttainmentService',
        'publicPersonModel',
        'organisationJSDataModel',
        'STUDENT_APPLICATION_STATE',
    ];
    /**
     * Use Angular component AttainmentWorkflowDecisionSummary instead in future development.
     *
     * @deprecated
     */
    angular
        .module(attainmentApplicationDecisionSummaryModule, [
            localizedUrnNameDisplayModule,
            decimalNumberFilterModule,
            personNameAndTitleModule,
            textWithDefaultMissingValueModule,
            'sis-components.model.gradeScale',
            'sis-components.model.publicPerson',
            'sis-components.model.studentApplication',
            'sis-components.model.organisation',
            'sis-components.service.attainmentService',
            MarkupStringComponent.downgrade.moduleName,
        ])
        .component('attainmentApplicationDecisionSummary', {
            template: attainmentApplicationDecisionSummaryTpl,
            bindings: {
                application: '<',
            },
            controller: attainmentApplicationDecisionSummaryController,
        });

    function attainmentApplicationDecisionSummaryController(
        $q,
        $scope,
        gradeScaleJSDataModel,
        commonAttainmentService,
        publicPersonModel,
        organisationJSDataModel,
        STUDENT_APPLICATION_STATE,
    ) {
        //NOSONAR
        $scope.STUDENT_APPLICATION_STATE = STUDENT_APPLICATION_STATE;

        var ctrl = this;
        ctrl.$onInit = function () {
            commonAttainmentService.findAttainmentsForStudentApplication(ctrl.application.id, true).then(function (attainments) {
                // Application should be linked to only one active attainment
                ctrl.attainment = _.find(attainments, function (attainment) {
                    return !attainment.misregistration && !!attainment.primary;
                });

                if (ctrl.attainment) {
                    ctrl.attainmentOrganisationsById = {};

                    if (ctrl.attainment.gradeScaleId && _.isNumber(ctrl.attainment.gradeId)) {
                        gradeScaleJSDataModel.find(ctrl.attainment.gradeScaleId).then(function (gradeScale) {
                            var grades = _.get(gradeScale, 'grades', []);
                            if (ctrl.attainment.gradeId < grades.length) {
                                ctrl.attainmentGrade = grades[ctrl.attainment.gradeId];
                            }
                        });
                    }
                    if (_.has(ctrl.attainment, 'acceptorPersons[0].personId')) {
                        publicPersonModel.find(ctrl.attainment.acceptorPersons[0].personId).then(function (person) {
                            ctrl.attainmentAcceptor = person;
                        });
                    }

                    if (ctrl.attainment.organisations) {
                        $q.all(
                            _.chain(ctrl.attainment.organisations)
                                .filter(organisation => !_.isNil(organisation.organisationId))
                                .map(organisationShare => organisationJSDataModel.find(organisationShare.organisationId))
                                .value(),
                        ).then(organisations => {
                            ctrl.attainmentOrganisationsById = _.keyBy(organisations, 'id');
                        });
                    }
                }
            });
        };

        ctrl.getAttainmentName = function () {
            if (_.hasIn(ctrl, 'attainment.courseUnit.name')) {
                return ctrl.attainment.courseUnit.name;
            } else if (_.hasIn(ctrl, 'attainment.name')) {
                return ctrl.attainment.name;
            }

            return { fi: '-' };
        };

        ctrl.applicationValue = function (fieldPath) {
            return _.get(ctrl.application, fieldPath);
        };

        ctrl.valueKey = function (value, translationKeyPrefix) {
            return value ? translationKeyPrefix + value : value;
        };

        ctrl.hasFinalDecision = function () {
            return (
                ctrl.application.decision &&
                _.includes(
                    [
                        STUDENT_APPLICATION_STATE.ACCEPTED,
                        STUDENT_APPLICATION_STATE.REJECTED,
                        STUDENT_APPLICATION_STATE.ACCEPTANCE_REVOKED,
                        STUDENT_APPLICATION_STATE.REVOKED,
                    ],
                    ctrl.application.state,
                )
            );
        };

        ctrl.isCourseUnitAttainment = function () {
            return _.get(ctrl, 'attainment.type') === 'CourseUnitAttainment';
        };

        ctrl.missingTextValueKey = 'STUDENT_APPLICATIONS.INFO_MISSING';
        ctrl.missingOptionValue = '-';
    }
})();
